import styled from 'styled-components';

const Details = styled.h5`
  font-weight: normal;
  font-family: ${Styles.fontFamily.body};
  font-size: 0.9375rem;
  margin: 0;
  padding: 0;
  text-transform: none;
  height: 1.25rem;

  ${Styles.desktop`
    font-size: 1rem;
    height: 1.2rem;
  `}
`;

export default Details;
